import { JanelaModal } from '../../participantes/ui/JanelaModal';

interface BotoesProps {
    verbo: string;
    processando: boolean;
    aoCancelar: () => void;
    aoConfirmar: () => void;
}

function Botoes({ verbo, processando, aoCancelar, aoConfirmar }: BotoesProps) {
    return (
        <div className="botoes-confirmacao">
            <button type="button" className="botao-secundario" onClick={aoCancelar} disabled={processando}>
                Cancelar
            </button>
            <button type="button" className="botao-confirmar botao-inativar" onClick={aoConfirmar} disabled={processando}>
                {processando ? 'Processando…' : verbo}
            </button>
        </div>
    );
}

interface ExcluirParticipanteProps extends Omit<BotoesProps, 'verbo'> {
    nome: string;
    /** Só para o líder com outro ativo no grupo: a frase do sorteio (`DP-RA-041`). */
    fraseDoLider?: string;
}

/** "Excluir definitivamente?" de `docs/img_refac/img_3.png` (`RA8`, `RN-RA-036`). */
export function ConfirmacaoDeExcluirParticipante({ nome, fraseDoLider, ...botoes }: ExcluirParticipanteProps) {
    return (
        <JanelaModal titulo="Excluir definitivamente?" aoFechar={botoes.aoCancelar} bloqueada={botoes.processando}>
            <p>{`Excluir ${nome} removerá seu cadastro e bloqueará seu acesso. Esta ação não poderá ser desfeita.`}</p>
            <p>Um administrador poderá cadastrar as suas credenciais novamente, mas todo seu progresso será perdido.</p>
            {fraseDoLider && <p>{fraseDoLider}</p>}
            <Botoes verbo="Excluir definitivamente" {...botoes} />
        </JanelaModal>
    );
}

/** "Excluir Grupo NN?" de `docs/img_refac/img_3.png` (`RA8`, `RN-RA-036`). */
export function ConfirmacaoDeExcluirGrupo({ rotulo, ...botoes }: Omit<BotoesProps, 'verbo'> & { rotulo: string }) {
    return (
        <JanelaModal titulo={`Excluir ${rotulo}?`} aoFechar={botoes.aoCancelar} bloqueada={botoes.processando}>
            <p>Excluir este grupo desvinculará todos os participantes associados a ele.</p>
            <p>Os participantes perderão seu progresso individual neste grupo e precisarão ser alocados novamente para continuar.</p>
            <Botoes verbo="Excluir grupo" {...botoes} />
        </JanelaModal>
    );
}
